export const palette = (theme) => ({
    contained: {
        iconColor: theme.palette.info.main,
        backgroundColor: theme.palette.info.main,
        textColor: theme.palette.info.contrastText,
        iconBackgroundColor: theme.palette.info.contrastText,
        iconBackgroundColorAlpha: 1,
    },
    outlined: {
        iconColor: theme.palette.primary.main,
        backgroundColor: theme.palette.background.paper,
        textColor: theme.palette.text.primary,
        iconBackgroundColor: theme.palette.primary.main,
        iconBackgroundColorAlpha: 0.25,
    },
});
export const sxStyles = ({ spacing, typography }) => ({
    root: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
    },
    header: {
        padding: `${spacing(3)} ${spacing(3)} 0px ${spacing(3)}`,
    },
    content: {
        padding: `${spacing(2)} ${spacing(3)} ${spacing(3)} ${spacing(3)}`,
    },
    icon: {
        width: "59px",
        height: "59px",
        "& .MuiSvgIcon-root": {
            width: "2rem",
            height: "2rem",
        },
    },
    title: { fontSize: typography.body1.fontSize, fontWeight: 700, marginBottom: `${spacing(2)}` },
});
//# sourceMappingURL=Teaser.style.js.map